import { InputTextType } from '../Enum/InputTextType';
import InputTextControl from './InputTextControl';
import ValidationMessages from '../Data/ValidationMessages';
export default class InputEmailControl extends InputTextControl {
    constructor(field) {
        super(field);
        this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.type = InputTextType.email;
    }
    validate(clearValidationMessages = true) {
        var _a;
        this.clearValidationMessages();
        this.field.isCustomValid = true;
        const rawVal = (_a = this.getRawValue()) === null || _a === void 0 ? void 0 : _a.toString();
        if (!this.emailRegex.test(rawVal)) {
            this.addValidationMessage(ValidationMessages.email());
            this.field.isCustomValid = false;
        }
        return super.validate(false);
    }
}
